/**
 * ProcessedDataChart Formatters
 * Date and time formatting utilities
 */

import { LOCALE } from '../constants';

/**
 * Format timestamp for axis display
 */
export function formatAxisTime(timestamp: number): string {
  const d = new Date(timestamp * 1000);
  return new Intl.DateTimeFormat(LOCALE, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(d);
}

/**
 * Format timestamp for display with full date
 */
export function formatDisplayTime(timestamp: number): string {
  const d = new Date(timestamp * 1000);
  return new Intl.DateTimeFormat(LOCALE, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(d);
}

/**
 * Format number for locale display
 */
export function formatNumber(value: number): string {
  return value.toLocaleString(LOCALE);
}
